import React, { useEffect, useMemo, useState } from 'react';
import fetchJson from '../hooks/fetchJson';
import { useAuth } from '../contexts/AuthContext';

const Refunds = () => {
  const { user, token } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copiedKey, setCopiedKey] = useState('');

  const headers = useMemo(() => ({
    ...(user?.ownerId ? { 'x-owner-id': String(user.ownerId) } : {}),
    ...(user?.staffId ? { 'x-staff-id': String(user.staffId) } : {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  }), [user, token]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      const { data, error } = await fetchJson('/api/refunds?limit=200', { headers });
      if (error) {
        setError(error);
        setItems([]);
      } else {
        setItems(Array.isArray(data?.items) ? data.items : []);
      }
      setLoading(false);
    };
    load();
  }, [headers]);

  const copyCombined = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedKey(text);
      setTimeout(() => setCopiedKey(''), 1200);
    } catch (e) {
      console.error('Copy failed', e);
    }
  };

  const formatNum = (n) => {
    const v = Number(n || 0);
    return Number.isInteger(v) ? v.toString() : v.toFixed(3);
  };

  return (
    <div className="container py-3 ">
      <div className="card shadow border-2">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Refunds</h5>
        </div>
        <div className="card-body">
          {loading && (
            <div className="d-flex align-items-center">
              <div className="spinner-border text-primary me-2" role="status" style={{ width: '1.5rem', height: '1.5rem' }} />
              <span>Loading...</span>
            </div>
          )}
          {!!error && (
            <div className="alert alert-danger py-2" role="alert">
              {error}
            </div>
          )}
          {!loading && !error && (
            <div className="table-responsive">
              <table className="table table-striped table-hover table-bordered align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Product</th>
                    <th>Customer</th>
                    <th className="text-end">Qty</th>
                    <th className="text-end">Price</th>
                    <th>Currency</th>
                    <th>Doer</th>
                    <th>Store</th>
                    <th>SellBatch / PurchaseBatch</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center text-muted">No refunds found</td>
                    </tr>
                  )}
                  {items.map((r) => {
                    const label = r.customer_type_label || (r.customer_type === 'customer1' ? 'Odatiy' : r.customer_type === 'customer3' ? 'Ulgurchi' : r.customer_type === 'customer2' ? 'Qarz' : (r.customer_type || ''));
                    const combined = `${r.sellbatchid || ''} / ${r.purchase_batch_id || ''}`;
                    const isCopied = copiedKey === combined;
                    return (
                      <tr key={r.id}>
                        <td>{r.product_name || r.productid}</td>
                        <td>{label}</td>
                        <td className="text-end">{formatNum(r.refund_quantity)}</td>
                        <td className="text-end">{formatNum(r.refund_price)}</td>
                        <td>{r.currency}</td>
                        <td>{r.doer_name || 'EGA'}</td>
                        <td>{r.store_name || r.storeid}</td>
                        <td>
                          <div className="d-flex align-items-center justify-content-between">
                            <span className="me-2 text-truncate" style={{ maxWidth: 220 }} title={combined}>{combined}</span>
                            <button
                              type="button"
                              className={`btn btn-sm ${isCopied ? 'btn-success' : 'btn-outline-secondary'}`}
                              onClick={() => copyCombined(combined)}
                              title="Copy"
                            >
                              {isCopied ? 'Copied' : 'Copy'}
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Refunds;